// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Navbar } from 'react-bootstrap';
import Navigation from '../Navigation';
import Logo from '../Logo';
import Toaster from '../Toaster';
import LoadingBar from 'react-redux-loading-bar';
import HeaderLocationSearch from './HeaderLocationSearch';
import DropDownMenu from '../DropDownMenu/DropDownMenu';

import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';
import history from '../../core/history';

import closeIcon from '/public/SiteIcons/loginClose.svg';

import s from './Header.css';

function HomeHeader(props) {
  const { showMenu, layoutType, homeHeaderOnly, account, isNotHomePage } = props;
  const [homeData, setHomeData] = useState({
    isOpen: 0,
    fixedBgClass: '',
    scrollLogo: false
  });
  const { isOpen, fixedBgClass, scrollLogo } = homeData;

  let headerDesignClass, location, homeHeader, layoutFive;

  if (layoutType && (layoutType != 2)) {
    headerDesignClass = 'headerNewDesign';
  }

  if (history.location) {
    location = history.location.pathname;
  }

  homeHeader = { ['homeHeader']: location === '/' || location === '/home' };
  layoutFive = (layoutType == 5 ? fixedBgClass : '');

  useEffect(() => {
    if (typeof window !== 'undefined' && Number(layoutType) === 5) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
    }
  }, [layoutType]);

  const handleMenu = () => {
    const { showMenu, toggleOpen, toggleClose } = props;
    showMenu ? toggleClose() : toggleOpen();
  }

  const openMenu = () => {
    setHomeData(prevObject => ({ ...prevObject, isOpen: 1 }));
  }

  const openClose = () => {
    setHomeData(prevObject => ({ ...prevObject, isOpen: 0 }));
  }

  const handleScroll = () => {
    let top = document.documentElement.scrollTop || document.body.scrollTop,
      isWeb = window.matchMedia('(min-width: 1300px)').matches;
    let fixedBgClass = '', scrollLogo = false;
    if (isWeb && top >= 80) {
      fixedBgClass = 'fixedBgHeader';
      scrollLogo = true;
    }
    setHomeData(prevObject => ({ ...prevObject, fixedBgClass, scrollLogo }));
  }

  return (
    <div className={cx(headerDesignClass)}>
      <div className={s.root}>
        <Toaster />
        <LoadingBar />
        <div>
          <Navbar className={
            cx(
              'commonHeader',
              homeHeader,
              layoutFive,
            )}
            expanded={showMenu}
            onToggle={handleMenu}
          >
            <div className={s.headerFlexBox}>
              <Navbar.Header className={cx('logoPadding', (!showMenu ? 'normalPosition' : 'fixedPosition'))}>
                <Navbar.Brand className={(s.homeLogo)}>
                  <Logo link={"/"} className={cx(s.brand, s.brandImg)} scrollLogo={scrollLogo} />
                </Navbar.Brand>
              </Navbar.Header>
              <div className={cx('hidden-lg', 'positionRelative')} onClick={openMenu}>
                <DropDownMenu />
              </div>
              {
                isNotHomePage && <Navbar.Form pullLeft className={('hidden-xs', s.breakPoint)}>
                  <HeaderLocationSearch />
                </Navbar.Form>
              }
              <div className={cx({ [s.menuOpen]: isOpen == 1 }, s.mobileMenu, 'homeMobileMenu')}>
                <div className={cx(s.closeButtonPosition, 'hidden-lg')}>
                  <div className={cx(s.closeColor, 'closeColorRTL', 'svgImg')} onClick={openClose} >
                    <img src={closeIcon} />
                  </div>
                </div>
                <div onClick={openClose}>
                  <Navigation openClose={isOpen} homeHeaderOnly={homeHeaderOnly}
                    homePage
                  />
                </div>
              </div>
            </div>
          </Navbar>
        </div>
      </div>
    </div>
  );
}

HomeHeader.propTypes = {
  borderLess: PropTypes.bool,
  showMenu: PropTypes.bool,
  toggleOpen: PropTypes.any.isRequired,
  formatMessage: PropTypes.any,
  checked: PropTypes.any
};

HomeHeader.defaultProps = {
  borderLess: false,
  showMenu: false
}

HomeHeader = reduxForm({
  form: 'HomeHeaderForm', // a unique name for this form
})(HomeHeader);

const mapState = (state) => ({
  showMenu: state.toggle.showMenu,
  layoutType: state.siteSettings.data.homePageType,
  account: state.account.data
});

const mapDispatch = {
  toggleOpen,
  toggleClose
};


export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
)(HomeHeader);
